import SelectedJobAd from '../types/SelectedJobAd';
import TitleAnalysis from '../types/TitleAnalysis';
import JobAd from '../types/JobAd';
import CustomJobAd from '../types/CustomJobAd';
import Recruitomat from '../types/Recruitomat';
import Requirements from '../types/Requirements';
import ReadabilityAndLengthAnalysis from '../types/ReadabilityAndLengthAnalysis';

const setJobIdMutation = SelectedJobAd.mutations.SET_JOB_AD;
const setTitleMutation = JobAd.mutations.SET_TITLE;
const setCustomJobAdMutation = CustomJobAd.mutations.SET_JOB_AD;

const BaAnalysis = (store) => {
    // Update analysis data when the selected item changes
    store.subscribe((mutation) => {
        switch (mutation.type) {
            case setJobIdMutation: {
                const id = mutation.payload;

                store.dispatch(JobAd.actions.LOAD_JOB_AD, { jobId: id });
                store.dispatch(Recruitomat.actions.LOAD_PREDICTIONS, id);
                store.dispatch(Requirements.actions.LOAD_REQUIREMENTS, {
                    jobAdId: id,
                });
                store.dispatch(
                    ReadabilityAndLengthAnalysis.actions
                        .LOAD_READABILITY_AND_LENGTH_ANALYSIS,
                    id,
                );
                store.commit(TitleAnalysis.mutations.RESET_SUGGESTIONS);
                break;
            }
            case setTitleMutation: {
                const title = mutation.payload;
                store.dispatch(TitleAnalysis.actions.LOAD_SCORE, { title });
                break;
            }
            case setCustomJobAdMutation: {
                const title = mutation.payload.title;
                const fulltext = mutation.payload.fulltext;
                store.dispatch(JobAd.actions.LOAD_CUSTOM_JOB_AD, {
                    title,
                    fulltext,
                });
                store.dispatch(Recruitomat.actions.LOAD_CUSTOM_PREDICTIONS, {
                    title,
                    fulltext,
                });
                store.dispatch(TitleAnalysis.actions.LOAD_SCORE, { title });
                store.dispatch(
                    Requirements.actions.LOAD_REQUIREMENTS_FREETEXT,
                    {
                        text: title + ' ' + fulltext,
                    },
                );
                store.dispatch(
                    ReadabilityAndLengthAnalysis.actions
                        .LOAD_READABILITY_FREETEXT_AND_LENGTH_ANALYSIS,
                    {
                        text: fulltext,
                    },
                );
                store.commit(TitleAnalysis.mutations.RESET_SUGGESTIONS);
                break;
            }
        }
    });
};

export { BaAnalysis };
